import { ModuleEnum } from "@lib/enum"
import filterService from "@services/filter/filterService"
import { action, makeAutoObservable, observable } from "mobx"

interface FilterOptionModel {
  mine: any[]
  recent: any[]
  shared: any[]
}

class FilterStore {
  @observable isLoading!: boolean
  @observable detailColumn!: any
  @observable listColumnForClient!: any[]
  @observable listFilter!: FilterOptionModel
  @observable detailFilter!: any

  constructor() {
    makeAutoObservable(this)

    this.listFilter = {
      mine: [],
      recent: [],
      shared: [],
    }
    this.listColumnForClient = []
    this.detailColumn = {}
    this.detailFilter = {}
  }
  // For client
  @action
  async getListColumnForClient(module: any) {
    this.isLoading = true
    const result = await filterService
      .getListColumnByModuleForClient(module)
      .finally(() => (this.isLoading = false))
    this.listColumnForClient = result
  }
  @action
  async newColumnFilter() {
    this.detailColumn = {
      id: 0,
    }
  }

  @action
  async getListFilter(module: ModuleEnum) {
    const result = await filterService.getListFilter(module)
    this.listFilter = result
  }
  @action
  async getFilter(id: number) {
    const result = await filterService.getFilter(id)
    this.detailColumn = result
  }
  @action
  async createOrUpdate(body: any) {
    this.isLoading = true
    const result = await filterService
      .createOrUpdateFilter(body)
      .finally(() => (this.isLoading = false))
    this.detailFilter = result
  }
  @action
  async deleteMine(id: any) {
    await filterService.deleteMine(id)
  }
}

export default FilterStore
